// extracted by mini-css-extract-plugin
export var box = "_1u-1";
export var checkboxRow = "_1u-8";
export var checked = "_1u-2";
export var descriptionSpacer = "_1u-a";
export var disabled = "_1u-3";
export var icon = "_1u-6";
export var input = "_1u-0";
export var labelSpacer = "_1u-9";
export var medium = "_1u-5";
export var small = "_1u-4";
export var text = "_1u-7";